import React from 'react'
import gql from 'graphql-tag'
import DeliveredUrl from 'components/shared/DeliveredUrl'
import DefaultProductStatus from '../../DefaultProductStatus'

const VisoProduct = ({product}) => {
  if (product.state === 'delivered') {
    return (
      <DeliveredUrl product={product} />
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

VisoProduct.fragment = gql`
  fragment VisoProduct on VisoProduct {
    assets {
      edges {
        node {
          id
          state
          ...on UrlAsset {url}
        }
      }
    }
  }
`

export default VisoProduct
